import { CHAT_VIEW_LAST_CHAT_ID_LOCALSTORAGE } from '../constants';
import { TChatId } from '../../../../../../types/rest/IRestChat';

export const getLastChatIdLocalStorage = (): TChatId => {
    const data = localStorage.getItem(CHAT_VIEW_LAST_CHAT_ID_LOCALSTORAGE);
    return data ? JSON.parse(data) : null;
}
